import { useState } from 'react'

export interface ValidationRule {
  pattern?:
    | RegExp
    | ((value: string, fields: Record<string, string>) => boolean)
  message: string | string[]
  required?: boolean
}

interface ValidationConfig {
  [key: string]: ValidationRule[]
}

interface ValidationErrors {
  [key: string]: string | undefined
}

const useValidation = (
  values: Record<string, string>,
  config: ValidationConfig,
) => {
  const [errors, setErrors] = useState<ValidationErrors>({})

  const validateInputs = () => {
    const newErrors: ValidationErrors = {}

    Object.entries(values).forEach(([field, value]) => {
      if (config[field]) {
        for (const rule of config[field]) {
          let isValid = true

          if (rule.required && !value.trim()) {
            isValid = false
          } else if (rule.pattern) {
            isValid =
              typeof rule.pattern === 'function'
                ? rule.pattern(value, values)
                : rule.pattern.test(value)
          }

          if (!isValid) {
            if (Array.isArray(rule.message)) {
              newErrors[field] = rule.message[0]
            } else {
              newErrors[field] = rule.message
            }
            break
          }
        }
      }
    })

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  return { errors, validateInputs, setErrors }
}

export default useValidation
